<template>
  <div>
    <div v-if="!showDonate" class="overlay" :class="donateLoc">
      <button class="button is-rounded is-small" @click="showDonate = true">
        {{ donateButton }}
      </button>
    </div>
    <div v-else>
      <DonateDialog @done="showDonate = false" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import DonateDialog from "@/components/DonateDialog.vue";

export default {
  name: "DonateButton",
  components: {
    DonateDialog
  },
  data: function() {
    return {
      showDonate: false
    };
  },
  computed: {
    ...mapState("player", ["donateButton", "donateLoc"])
  }
};
</script>

<style scoped lang="scss">
.tl {
  top: 20px;
  left: 20px;
}

.tr {
  top: 20px;
  right: 20px;
}

.bl {
  bottom: 20px;
  left: 20px;
}

.br {
  bottom: 20px;
  right: 20px;
}

.plyr .br,
.plyr .bl {
  transform: translateY(-100%);
  transition: transform 0.4s ease-in-out;
}

.plyr--hide-controls .bl,
.plyr--hide-controls .br {
  transform: translateY(0%);
}

.overlay {
  position: absolute;
  z-index: 1000;
}

.overlay .button {
  opacity: 1;
  color: white;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.5s linear;
}

.plyr--hide-controls .overlay .button {
  opacity: 0;
  transition: opacity 5s linear;
}
</style>
